import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface TestimonialCardProps {
  name: string;
  role: string;
  image: string;
  alt: string;
  rating: number;
  text: string;
  plan: string;
}

export default function TestimonialCard({
  name,
  role,
  image,
  alt,
  rating,
  text,
  plan
}: TestimonialCardProps) {
  return (
    <div className="bg-card border border-border rounded-xl p-6 hover:shadow-cyan-glow transition-all duration-200">
      <div className="flex items-center space-x-4 mb-4">
        <div className="relative w-12 h-12 rounded-full overflow-hidden">
          <AppImage
            src={image}
            alt={alt}
            className="object-cover w-full h-full"
          />
        </div>
        <div className="flex-1">
          <h4 className="font-heading font-semibold text-foreground">{name}</h4>
          <p className="text-xs text-muted-foreground">{role}</p>
        </div>
        <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded">
          {plan}
        </span>
      </div>

      <div className="flex items-center space-x-1 mb-3">
        {[...Array(5)].map((_, index) => (
          <Icon
            key={index}
            name="StarIcon"
            variant={index < rating ? 'solid' : 'outline'}
            size={16}
            className={index < rating ? 'text-warning' : 'text-muted-foreground'}
          />
        ))}
      </div>

      <p className="text-sm text-foreground leading-relaxed">{text}</p>
    </div>
  );
}